var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverviewBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 613,
    height: 342,
    viewBox: "0 0 613 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M650.441.445c-85.04 1.679-172.379 24.053-237.35 89.369-41.548 41.595-69.892 94.636-81.449 152.418-11.545-57.786-39.891-110.83-81.448-152.418C188.209 27.499 104.943 2.48 24.372.36 20.57.36 16.77.214 12.99.214H0v37.632c0 4.954.104 9.907.355 14.86 3.488 72.725 32.475 146.017 86.962 200.776 57.724 58.012 168.495 87.27 244.138 87.732h.292c75.789-.462 186.392-29.699 244.158-87.753 55.741-55.997 84.77-131.43 87.151-205.687V.444h-12.615zM102.667 232.766c.209 0 0 0 0 0z",
    fill: "#F8F5FF"
  })));
}
export default SvgOverviewBottom;